/**
 * Encapsulates the name and value for an HTTP Header
 */
export class Header {
  public constructor(
    public name: string,
    public value: string,
  ) {}
}
